/**
 * Created by Tiger on 24/02/2022.
 */
import Types from '../types';
import i18n from '../../../i18n/i18n';

export default function onChangeLanguage(language) {
    return async dispatch => {
        i18n.changeLanguage(language).then(() => {
            localStorage.setItem('language', language);
            dispatch({
                type: Types.LANGUAGE, language,
            });
        });
    };
}
